export const FILTER_SEARCH_ID = "filter-search";
export const GEO_SEARCH_ID = "geo-search";
export const FILTERS_BUTTON_SELECTOR = '#filters-button';

export const FILTER_NAMES: {
    OPERATION_TYPE: string,
    PROPERTY_TYPE: string,
    TYPE: string,
    PRICE: string,
    MIN_PRICE: string,
    MAX_PRICE: string,
    ROOMS: string,
    MIN_BEDROOMS: string,
    BATHROOMS: string,
    MIN_BATHROOMS: string,
    AREA: string,
    MIN_AREA: string,
    MAX_AREA: string,
    SORTING: string,
    AMENITIES: string,
    GEO_ID: string,
    FREE_TEXT: string,
    GEO_CHILDREN_ID: string,
    DAYS_SINCE_PUBLICATION: string,
    BANK_PROPERTY: string,
    LOCATION: string,
    FURNISHED: string,
    STRATUM: string,
    NEARBY_POI_TYPE_DISTANCE: string,
} = {
    OPERATION_TYPE: "operationType",
    PROPERTY_TYPE: "propertyType",
    TYPE: "type",
    PRICE: "price",
    MIN_PRICE: "minPrice",
    MAX_PRICE: "maxPrice",
    ROOMS: "rooms",
    MIN_BEDROOMS: "minBedrooms",
    BATHROOMS: "bathrooms",
    MIN_BATHROOMS: "minBathrooms",
    AREA: "area",
    MIN_AREA: "minArea",
    MAX_AREA: "maxArea",
    SORTING: "sorting",
    AMENITIES: "amenities",
    GEO_ID: "geoId",
    FREE_TEXT: "freeText",
    GEO_CHILDREN_ID: "geoChildrenId",
    DAYS_SINCE_PUBLICATION: "daysSincePublication",
    BANK_PROPERTY: "bankProperty",
    LOCATION: "location", // Used for web tracking FiltersUpdatedEvent: we should use "geo" in the avro schema event
    FURNISHED: "furnished",
    STRATUM: "stratum",
    NEARBY_POI_TYPE_DISTANCE: "nearbyPoiType",
};
export const MODAL_FILTERS_SELECTOR = '.filters-section .filter-option';
export const MODAL_FILTERS_CONTAINER_SELECTORS: {[key: string]: string} = {
    [FILTER_NAMES.OPERATION_TYPE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-operation-type`,
    [FILTER_NAMES.PROPERTY_TYPE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-property-type`,
    [FILTER_NAMES.FREE_TEXT]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-free-text`,
    [FILTER_NAMES.PRICE]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-price`,
    [FILTER_NAMES.STRATUM]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-stratum`,
    [FILTER_NAMES.ROOMS]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-bedrooms`,
    [FILTER_NAMES.BATHROOMS]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-bathrooms`,
    [FILTER_NAMES.AREA]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-area`,
    [FILTER_NAMES.SORTING]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-sorting`,
    [FILTER_NAMES.AMENITIES]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-amenities`,
    [FILTER_NAMES.GEO_CHILDREN_ID]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-geo-children`,
    [FILTER_NAMES.DAYS_SINCE_PUBLICATION]: `${MODAL_FILTERS_SELECTOR}.modal-filter-option-days-since-publication`,
    [FILTER_NAMES.BANK_PROPERTY]: `${MODAL_FILTERS_SELECTOR}.filter-option modal-filter-option-property-situation`,
    [FILTER_NAMES.NEARBY_POI_TYPE_DISTANCE]: `${MODAL_FILTERS_SELECTOR}.filter-option modal-filter-option-nearby-poi-type-distance`,
    [FILTER_NAMES.FURNISHED]: `${MODAL_FILTERS_SELECTOR}.filter-option modal-filter-option-furnished`,
}
export const FILTERS_FORM_MODAL_SELECTOR = '#filters-form-bar';
export const FILTERS_MODAL_FORM_SELECTOR = "#filters-form-bar";
export const FILTERS_BAR_FORM_SELECTOR = "#filters-bar";
export const FILTERS_SERP_SUGGESTION_FORM_SELECTOR = "#home-search-box-form";
export const FILTERS_CLEAR_ALL_BUTTON_SELECTOR = ".filters__clear-all";
